import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

export const TagsTooltipForStrategyWrapper = styled.div`
  padding: 2px 4px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  line-height: 16px;
  color: ${colors.intenseBlue};
  background-color: ${colors.blueLight};
  :hover {
    background-color: ${colors.blueLightHover};
  }
`;
